import React from 'react';
import HoverMenu from 'ats/components/hover-menu/HoverMenu';
import { countryStore } from './CountryStore';
import { CountryEdit } from './CountryEdit';
import { observer } from 'mobx-react';
import { ListStore } from '../../../shared/stores/ListStore';
import SettingsTableSkeleton from '../SettingsTableSkeleton';
import {
	rolesAllowed,
	USER_ROLES
} from '../../../shared/security/RolesAllowed';
import SettingsSubsectionHeader from '../SettingsSubsectionHeader';
import SettingsListToolbar from '../SettingsListToolbar';
import SettingsListEmptyState from '../SettingsListEmptyState';
import { getSettingsSectionLabel } from '../settingsSections';

@rolesAllowed([USER_ROLES.ADMIN])
@observer
export class Countries extends React.Component {
	state = {
		data: [],
		filterText: '',
		loading: true
	};

	constructor(props) {
		super(props);
		this.listStore = new ListStore(countryStore, {
			entityName: 'Country',
			editModal: item => (
				<CountryEdit
					country={item}
					handleSuccess={() => {
						this.search();
						this.setState({ filterText: '' });
					}}
				/>
			)
		});
	}

	componentDidMount() {
		this.search();
	}

	search(value) {
		value = value ? value : '';
		this.setState({ loading: true });
		countryStore.getCountries(value).then(result => {
			if (result.status === 'success' && result.data) {
				this.setState({ data: result.data, loading: false });
			}
		});
	}

	getMenuItems(row) {
		return [
			{
				label: 'Edit',
				img: '/ats/icons/edit-icon.svg',
				onClick: () => this.listStore.handleEdit(row)
			}
		];
	}

	hasFilters = () => Boolean(this.state.filterText.trim());

	clearFilters = () => {
		this.setState({ filterText: '' }, () => {
			this.search();
		});
	};

	render() {
		const { data, loading, filterText } = this.state;
		const isEmpty = !loading && data.length === 0;

		return (
			<div className="Countries container">
				<SettingsSubsectionHeader
					title={getSettingsSectionLabel('countries')}
					actions={
						<SettingsListToolbar
							searchValue={filterText}
							onSearchChange={value => {
								this.search(value);
								this.setState({ filterText: value });
							}}
						/>
					}
				/>
				<div className="columns">
					<div className="column is-12 table-wrapper">
						<table className="table is-fullwidth">
							<thead>
								<tr>
									<th>Code</th>
									<th>Name</th>
									<th className="actions-column" />
								</tr>
							</thead>
							{loading ? (
								<SettingsTableSkeleton columns={3} />
							) : !isEmpty ? (
								<tbody>
									{data.map(row => {
										return (
											<tr key={row.id}>
												<td className="has-text-weight-bold">{row.id}</td>
												<td className="has-text-weight-bold">{row.name}</td>
												<td className="actions-column">
													<HoverMenu
														id={row.id}
														position="left"
														buttonIcon={
															<img
																src="/ats/icons/three-dots-icon.svg"
																alt="More actions"
															/>
														}
														items={this.getMenuItems(row)}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							) : null}
						</table>
						{!loading && isEmpty ? (
							<SettingsListEmptyState
								entityPlural="countries"
								hasFilters={this.hasFilters()}
								onClearFilters={this.clearFilters}
							/>
						) : null}
					</div>
				</div>
			</div>
		);
	}
}
